import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { CheckInOutReportComponent } from './check-in-out-report.component';
import { RouterModule } from '@angular/router';
import { AuthGuardService } from '../../authentication/auth-guard.service';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseSidebarModule } from '@fuse/components';
import { FuseWidgetModule } from '@fuse/components/widget/widget.module';
import { TableModule } from 'primeng/table';
import { MultiSelectModule, ChartModule } from 'primeng/primeng';
import { SharedModule } from 'app/shared/shared.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { HighchartsChartModule } from 'highcharts-angular';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';

const routes = [
  { path: '', redirectTo: 'CheckInOut', pathMatch: 'full', canActivate: [AuthGuardService] },
  { path: 'CheckInOut', component: CheckInOutReportComponent, canActivate: [AuthGuardService] },
];

@NgModule({
  declarations: [CheckInOutReportComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FuseSharedModule,
    FuseSidebarModule,
    FuseWidgetModule,
    TableModule,
    MultiSelectModule,
    ChartModule,
    SharedModule,
    MatTooltipModule,
    MatSidenavModule,
    MatButtonModule,
    MatSelectModule,
    MatInputModule,
    MatDatepickerModule,
    HighchartsChartModule,
    MatIconModule,
    MatFormFieldModule
  ],
  providers: [DatePipe]
})

export class CheckInOutReportModule { }
